import { camelCase } from 'lodash';

export default function styleObject(strings, ...values) {
	const text = strings.map((s, i) => (values[i] ? s + values[i] : s)).join('');
	const rules = text.split(';').filter((r) => r.trim());
	return Object.assign(
		...rules.map((rule) => {
			const [rawName, rawValue] = rule.split(':');
			const name = camelCase(rawName);
			const value = /^\d+$/.test(rawValue.trim()) ? Number(rawValue) : rawValue.trim();
			return { [name]: value };
		})
	);
}



// WEBPACK FOOTER //
// ./src/style-object.js